export const validarEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email || !email.trim()) return 'El email es obligatorio.';
  if (!regex.test(email)) return 'El email no es válido.';
  return null;
};

export const validarTexto = (valor, campo, min = 2) => {
  if (!valor || valor.trim().length < min)
    return `${campo} debe tener al menos ${min} caracteres.`;
  return null;
};

export const validarMonto = (monto) => {
  const valor = parseFloat(monto);
  if (isNaN(valor) || valor <= 0) return 'El monto debe ser mayor a cero.';
  return null;
};

export const validarFecha = (fecha) => {
  if (!fecha) return 'La fecha es obligatoria.';
  if (isNaN(new Date(fecha).getTime())) return 'Fecha inválida.';
  return null;
};

export const validarPassword = (password) => {
  if (!password || password.length < 6)
    return 'La contraseña debe tener al menos 6 caracteres.';
  return null;
};